module.exports = __webpack_public_path__ + "assets/img/sdwan-module1-3.4a24ca4f.png";